document.addEventListener("DOMContentLoaded", function() {
    let flkty = new Flickity('.Carousel');
    if(innerWidth > 500){
        document.getElementById('360imagecss').remove();
    }

    document.querySelector(`[data-image-id="360"]`).addEventListener('click', () => {
        $('html, body').animate({
            scrollTop: $("#360Image").offset().top - (document.querySelector('.Header__Wrapper').offsetHeight + (innerWidth > 1250 ? 30 : 60))
        }, 400);
    })
    let resizeWait
    window.addEventListener('resize', () => {

        clearTimeout(resizeWait);
        resizeWait = setTimeout(reInit, 400);
    });

    Window.three_sixty =  new ThreeSixty(document.getElementById('360Image'), {
        image: document.querySelector('[data-imgset]').dataset.imgset,
        width: document.querySelector('#imageZoom').offsetWidth,
        height: document.querySelector('#imageZoom').offsetHeight,
        count: 35,
        perRow: 35,
        speed: 50,
        swipeTarget : document.getElementById('360Image'),
        prev: document.getElementById('prev'),
        next: document.getElementById('next')
    })

    flkty.on( 'change', function(index ) {
        if(index == flkty.cells.length - 1){
            Window.three_sixty.play();
        }

    });

    setTimeout(() => {
        if(document.getElementById('360imagecss')){
            document.getElementById('360imagecss').remove();
        }
    }, 1500);

    document.getElementById('360Image').addEventListener('mousedown', e => {
        document.body.classList.add("unselect")


    });

    document.getElementById('360Image').addEventListener("touchstart",() =>{
        flkty.options.draggable = false;
        flkty.updateDraggable();
    });

    document.querySelector('.go_back_360').addEventListener('click', () => {
        flkty.previous();
    })


    document.getElementById('360Image').addEventListener("touchend", () =>{
 
        flkty.options.draggable = true;
        flkty.updateDraggable(); 
        flkty.next()
    }, false);


    document.addEventListener('mouseup', e => {
        document.body.classList.remove("unselect")

    })

    reInit();
    
});
  
function reInit(){
    Window.three_sixty.destroy();
    Window.three_sixty =  new ThreeSixty(document.getElementById('360Image'), {
        image: document.querySelector('[data-imgset]').dataset.imgset,
        width: document.querySelector('#imageZoom').offsetWidth,
        height: document.querySelector('#imageZoom').offsetHeight,
        count: 35,
        perRow: 35,
        speed: 50,
        prev: document.getElementById('prev'),
        next: document.getElementById('next')
    })

    // Window.three_sixty.play();

}
